/**
 * Dashboard access helpers — mirrors MenuLeft / router role + pack checks.
 */

export function getActiveBuilding(user, settings) {
  const buildings = (user && user.building) || [];
  const active = settings && settings.activeBuilding;
  return buildings.find((b) => b.dbName === active) || buildings[0] || null;
}

/** Pack value: "v" | "d" | "h" | undefined */
export function getPackAccess(user, settings, accessPack) {
  if (!accessPack) return "v";
  const building = getActiveBuilding(user, settings);
  const pack =
    building &&
    building.pack &&
    building.pack.access &&
    building.pack.access.edManager &&
    building.pack.access.edManager[accessPack];
  return pack || "h";
}

/**
 * Role check — same idea as MenuLeft.verifyRole / router.verifyRoleAccess.
 */
export function hasRoleAccess(userAccess, feature) {
  if (!feature) return false;
  if (!userAccess) return false;
  if (userAccess.all) return true;

  const accessGroup = feature.accessGroup;
  const roles = feature.roles;
  if (!accessGroup || !Array.isArray(roles) || roles.length === 0) return true;

  const groupAccess = userAccess[accessGroup];
  if (groupAccess === true) return true;

  if (Array.isArray(groupAccess)) {
    return roles.some((role) => groupAccess.includes(role));
  }

  // Boolean groups (actualite, calendar, notifications, …)
  return roles.some((role) => userAccess[role] === true);
}

/** Widget: show only if role OK and pack is not hidden */
export function canShowFeature(user, settings, feature) {
  if (!feature) return false;
  if (!hasRoleAccess(user && user.access, feature)) return false;
  const pack = getPackAccess(user, settings, feature.accessPack);
  return pack !== "h";
}

/** Quick access: enabled only if role OK and pack is fully visible ("v") */
export function canUseFeature(user, settings, feature) {
  if (!feature) return false;
  if (!hasRoleAccess(user && user.access, feature)) return false;
  const pack = getPackAccess(user, settings, feature.accessPack);
  return pack === "v";
}

/** Feature keys used by the accueil dashboard */
export const DASHBOARD_FEATURES = {
  actualite: {
    accessGroup: "actualite",
    roles: ["actualite"],
    accessPack: "news",
  },
  calendar: {
    accessGroup: "calendar",
    roles: ["calendar"],
    accessPack: "calender",
  },
  punition: {
    accessGroup: "scolarite",
    roles: ["punition"],
    accessPack: "punishments",
  },
  emplois: {
    accessGroup: "emplois",
    roles: ["eleves"],
    accessPack: "emplois",
  },
  eleves: {
    accessGroup: "liste_eleves",
    roles: ["liste_eleves"],
    accessPack: "studentList",
  },
  bulletin: {
    accessGroup: "bulletin",
    roles: ["pedagogic", "pilote", "specific", "statistique"],
    accessPack: "bulletin",
  },
  financial: {
    accessGroup: "home",
    roles: ["financialStats", "statstiqueGeneral", "usersStats", "all"],
    accessPack: "financialStats",
  },
  cantine: {
    accessGroup: "activite",
    roles: ["cantine"],
    accessPack: "cantine",
  },
  etablissement: {
    accessGroup: "parametrage",
    roles: ["etablissement", "all"],
    accessPack: "statstiqueGeneral",
  },
  notifications: {
    accessGroup: "notifications",
    roles: ["notifications"],
    accessPack: null,
  },
  chat: {
    accessGroup: "chat",
    roles: ["chat", "all"],
    accessPack: "chat",
  },
};
